'use client'

import React, {
  createContext,
  useContext,
  useState,
} from 'react'

const GenerativeSessionContext = createContext(
  undefined
)

export const GenerativeSessionProvider = ({
  children,
}) => {
  const [generativeSessionSeedId, setGenerativeSessionSeedId] = useState("")
  const [loadingSeedId, setLoadingSeedId] = useState(null)

  return (
    <GenerativeSessionContext.Provider
      value={{
        generativeSessionSeedId,
        setGenerativeSessionSeedId,
        loadingSeedId,
        setLoadingSeedId,
      }}
    >
      {children}
    </GenerativeSessionContext.Provider>
  )
}

export const useGenerativeSessionSeed = () => {
  const context = useContext(GenerativeSessionContext)
  if (!context) {
    throw new Error('useGenerativeSessionSeed must be used within a GenerativeSessionProvider')
  }
  return context
}
